import React from 'react';

function PinIcon() {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        // eslint-disable-next-line max-len
        d="M0 8.3178C0 3.71789 3.84388 0 8.4934 0C13.1561 0 17 3.71789 17 8.3178C17 10.6357 16.157 12.7876 14.7695 14.6116C13.2388 16.6235 11.3522 18.3765 9.2285 19.7524C8.7425 20.0704 8.3039 20.0944 7.7704 19.7524C5.63474 18.3765 3.74809 16.6235 2.2305 14.6116C0.84198 12.7876 0 10.6357 0 8.3178ZM5.69423 8.5768C5.69423 10.1177 6.9517 11.3297 8.4934 11.3297C10.0362 11.3297 11.3058 10.1177 11.3058 8.5768C11.3058 7.0478 10.0362 5.77683 8.4934 5.77683C6.9517 5.77683 5.69423 7.0478 5.69423 8.5768Z"
        fill="#F35227"
      />
    </svg>
  );
}

PinIcon.propTypes = {};

export default PinIcon;
